import React from 'react'
import { Link } from 'react-router-dom'
import SignupForm from '../../components/auth/SignupForm'
import { BarChart3 } from 'lucide-react'

const Signup = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        {/* Logo */}
        <div className="flex justify-center">
          <div className="flex items-center space-x-2">
            <BarChart3 className="h-10 w-10 text-primary-600" />
            <h1 className="text-2xl font-bold text-gray-900">
              Founder Sourcing Agent
            </h1>
          </div>
        </div>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="card">
          <SignupForm />
        </div>
      </div>

      {/* Footer */}
      <div className="mt-8 text-center">
        <p className="text-sm text-gray-600">
          By creating an account, you agree to our{' '}
          <Link to="/terms" className="text-primary-600 hover:text-primary-500 font-medium">
            Terms of Service
          </Link>{' '}
          and{' '}
          <Link to="/privacy" className="text-primary-600 hover:text-primary-500 font-medium">
            Privacy Policy
          </Link>
        </p>
      </div>
    </div>
  )
}

export default Signup
